export default "__VITE_ASSET__DAHapmP___"